<template>
  <div>
    <Sheet v-model="isOpen" title="Lists" size="lg" content-class="p-0" :fullscreen="fullscreen">
      <AddToListSheetInner
        v-if="isOpen && title"
        :title="title"
        :title-info="titleInfo"
        :user-title-info="userTitleInfo"
        :metadata="metadata"
        @close="isOpen = false" />
    </Sheet>
  </div>
</template>

<script setup>
import { computed } from 'vue'
import { Sheet } from '@/components/Options'
import AddToListSheetInner from '@/components/Sheets/AddToListSheetInner.vue'

const props = defineProps({
  modelValue: {
    type: Boolean,
    default: false
  },
  title: {
    type: Object,
    default: null
  },
  titleInfo: {
    type: Object,
    default: null
  },
  userTitleInfo: {
    type: Object,
    default: null
  },
  metadata: {
    type: Object,
    default: null
  },
  fullscreen: {
    type: Boolean,
    default: false
  }
})

const emit = defineEmits(['update:modelValue', 'close'])

const isOpen = computed({
  get: () => props.modelValue,
  set: (value) => {
    emit('update:modelValue', value)
    if (!value) emit('close')
  }
})
</script>
